enum ScoreSortOrder{
    RECENT='recent',
    TOP='top'
}

export default ScoreSortOrder
